import React from "react";
import Card from "./Card";
import generateCarUrl from "../modules/generateCarUrl";
import useWindowSize from "./useWindowSize";

function HighlightedCars() {
    const data = window.highlightedCars || [];
    
    const {width} = useWindowSize();

    return (
        <section className="my-3" style={{ minHeight: width > 768 ? "1100px":"2000px" }}>
            <div className="row justify-content-center mx-3">
                {data.map(vehicle => {
                    const {
                        list_images,
                        name,
                        id,
                        make,
                        model,
                        gear_type,
                        registration_year,
                        registration_month,
                        price,
                        mileage,
                        fuel,
                        power
                    } = vehicle;

                    return (
                        <div className="col-sm-6 my-2 col-lg-3" key={id}>
                            <Card
                                img={list_images[0]}
                                name={name}
                                make={make}
                                model={model}
                                gear_type={gear_type}
                                registration_year={registration_year}
                                registration_month={registration_month}
                                mileage={mileage}
                                price={price}
                                id={id}
                                carUrl={
                                    generateCarUrl({
                                    id,
                                    make,
                                    model,
                                    price,
                                    registration_year,
                                    registration_month,
                                    })
                                }
                                fuel={fuel}
                                power={power}
                            />
                        </div>
                    );
                })}
                <a
                    href="/lista-carros-usados-stand-pombal"
                    className="text-white col-12 mb-2 mt-4 d-flex justify-content-center"
                >
                    <div className="seeAll">
                        VER TODOS OS VEÍCULOS
                    </div>
                </a>
            </div>
        </section>
    );
}

export default HighlightedCars;
